import React from "react";
import { BsDot } from "react-icons/bs";

const CustomBanner = ({image,title,breadTitle}) => {
  return (
    <div className="flex items-center relative">
      <img alt="" src={image} className="w-full h-full object-cover max-md:h-52" />
      <div className="absolute w-full">
        <div className="container">
          <div className="flex items-center gap-2">
            <p className="text-main text-lg font-semibold mb-4">Ana Sayfa</p>
            <p className="text-main text-lg font-semibold mb-4">
              <BsDot size={22} />
            </p>
            <p className="text-main text-lg font-semibold mb-4">{breadTitle}</p>
          </div>
          <h1 className="font-semibold text-5xl">{title}</h1>
        </div>
      </div>
    </div>
  );
};

export default CustomBanner;
